export default __webpack_public_path__ + "static/media/Commander's Gauntlets of Heaven's Pass.aed7b768.jpg";